/// <amd-module name="typeahead/core/message/ElementFocusedMessage" />

import {TypeaheadMessage} from "typeahead/core/message/TypeaheadMessage";

export class ElementFocusedMessage implements TypeaheadMessage {

    public static getTopic(): string {
        return "typeahead.element_focused";
    }

    private readonly domElementId: string;
    private readonly elementValue: string;
    private readonly context: IContext;

    constructor(elementValue: string, context: IContext, domElementId: string) {
        this.elementValue = elementValue;
        this.domElementId = domElementId;
        this.context = context;
    }

    public getTopic(): string {
        return ElementFocusedMessage.getTopic();
    }

    public getDomElementId(): string {
        return this.domElementId;
    }

    public getElementValue(): string {
        return this.elementValue;
    }

    public getContext(): IContext {
        return this.context;
    }
}
